export const UPDATE_SERVICEWORKER = "UPDATE_SERVICEWORKER";

export function updateServiceworker() {
  return {
    type: UPDATE_SERVICEWORKER
  };
}

const initialState = {
  serviceWorkerUpdated: false
};

const serviceWorker = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SERVICEWORKER: {
      return {
        ...state,
        serviceWorkerUpdated: true
      };
    }
    default:
      return state;
  }
};

export default serviceWorker;
